module.exports = __webpack_public_path__ + "static/media/Preisliste Kurzzeitpflege.1c885c2b.pdf";